// eslint-disable-next-line @typescript-eslint/no-restricted-types
export const isObject = (value) => value !== null && typeof value === 'object';
//# sourceMappingURL=is.js.map